export default "assets/images/icons/play-973a6d85.svg";